window['ThemeTile'] = (link, title, carouselOptions = null) => {
  const base = {
    hover: false,
    link,
    title,
    showLabel() {
      this.labelContent = this.$refs.labelContent.innerHTML;
      this.focusVisible = this.$refs.tileLink.matches(':focus-visible');
    },
    hideLabel() {
      this.labelContent = '';
      this.focusVisible = false;
    },
    async openQuickView() {
      this.$store.quickview.render(link);
      this.$store.modals.open('productQuickView');
    },
  };

  const count =
    carouselOptions && typeof carouselOptions.imageCount === 'number'
      ? carouselOptions.imageCount
      : 0;

  const quickViewDesktop = !!(
    carouselOptions && carouselOptions.quickViewDesktop
  );
  const quickViewMobile = !!(
    carouselOptions && carouselOptions.quickViewMobile
  );

  if (count < 2) {
    return base;
  }

  return {
    ...base,
    carouselQuickViewDesktop: quickViewDesktop,
    carouselQuickViewMobile: quickViewMobile,
    tileCarouselIndex: 0,
    tileCarouselCount: count,
    tileCarouselTouchStartX: null,
    tileCarouselTouchMoved: false,
    tileCarouselSuppressClickUntil: 0,
    tileCarouselTrackTransformStyle() {
      const n = this.tileCarouselCount;
      const pct = (this.tileCarouselIndex / n) * 100;
      return {
        width: `${n * 100}%`,
        transform: `translate3d(-${pct}%, 0, 0)`,
      };
    },
    init() {
      this.$nextTick(() => {
        const imgs = this.$el?.querySelectorAll?.('.tile-product__carousel-slide img');
        const first = imgs?.[0];
        if (first?.complete && typeof first.decode === 'function') {
          first.decode().catch(() => {});
        }
      });
    },
    tileCarouselArmPreload() {
      if (this._tileCarouselPrefetchArmed) return;
      this._tileCarouselPrefetchArmed = true;
      const imgs = this.$el?.querySelectorAll?.('.tile-product__carousel-slide img');
      if (!imgs?.length) return;
      imgs.forEach((img) => {
        if (img.loading === 'lazy') img.loading = 'eager';
      });
      requestAnimationFrame(() => {
        imgs.forEach((img) => {
          if (img.complete && typeof img.decode === 'function') {
            img.decode().catch(() => {});
          }
        });
      });
    },
    tileCarouselAfterSlideChange() {
      this.$nextTick(() => {
        const imgs = this.$el?.querySelectorAll?.('.tile-product__carousel-slide img');
        if (!imgs?.length) return;
        const n = this.tileCarouselCount;
        const idx = this.tileCarouselIndex;
        const neighbors = [idx, (idx + 1) % n, (idx - 1 + n) % n];
        neighbors.forEach((i) => {
          const img = imgs[i];
          if (!img) return;
          if (img.loading === 'lazy') img.loading = 'eager';
          if (img.complete && typeof img.decode === 'function') {
            img.decode().catch(() => {});
          }
        });
      });
    },
    tileCarouselPrev(event) {
      event?.preventDefault();
      event?.stopPropagation();
      this.tileCarouselArmPreload();
      this.tileCarouselIndex =
        (this.tileCarouselIndex - 1 + this.tileCarouselCount) % this.tileCarouselCount;
      this.tileCarouselAfterSlideChange();
    },
    tileCarouselNext(event) {
      event?.preventDefault();
      event?.stopPropagation();
      this.tileCarouselArmPreload();
      this.tileCarouselIndex = (this.tileCarouselIndex + 1) % this.tileCarouselCount;
      this.tileCarouselAfterSlideChange();
    },
    tileCarouselTouchStart(event) {
      if (!event?.touches?.length) return;
      this.tileCarouselTouchStartX = event.touches[0].clientX;
      this.tileCarouselTouchMoved = false;
    },
    tileCarouselTouchMove(event) {
      if (this.tileCarouselTouchStartX == null) return;
      if (Math.abs(event.touches[0].clientX - this.tileCarouselTouchStartX) > 14) {
        this.tileCarouselTouchMoved = true;
      }
    },
    tileCarouselTouchEnd(event) {
      if (!event?.changedTouches?.length) return;
      const startX = this.tileCarouselTouchStartX;
      this.tileCarouselTouchStartX = null;
      if (startX == null) return;
      const endX = event.changedTouches[0].clientX;
      const dx = endX - startX;
      if (Math.abs(dx) > 42) {
        this.tileCarouselSuppressClickUntil = performance.now() + 350;
        this.tileCarouselArmPreload();
        if (dx < 0) {
          this.tileCarouselIndex = (this.tileCarouselIndex + 1) % this.tileCarouselCount;
        } else {
          this.tileCarouselIndex =
            (this.tileCarouselIndex - 1 + this.tileCarouselCount) % this.tileCarouselCount;
        }
        this.tileCarouselAfterSlideChange();
      }
      this.tileCarouselTouchMoved = false;
    },
    async tileCarouselBackdropClick(event) {
      if (event?.target.closest('[data-tile-carousel-control]')) return;
      if (performance.now() < this.tileCarouselSuppressClickUntil) return;

      const isWide = typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 990px)').matches;
      const wantsQuickView = isWide
        ? this.carouselQuickViewDesktop
        : this.carouselQuickViewMobile;
      if (wantsQuickView && this.$store?.quickview) {
        event?.preventDefault();
        await this.openQuickView();
        return;
      }
      if (typeof link !== 'string' || !link) return;
      window.location.href = link;
    },
    async tileContentClick(event) {
      if (!event) return;
      const isWide =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(min-width: 990px)').matches;
      const wantsQuickView = isWide
        ? this.carouselQuickViewDesktop
        : this.carouselQuickViewMobile;
      if (!wantsQuickView || !this.$store?.quickview) return;
      event.preventDefault();
      await this.openQuickView();
    },
  };
};
